/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */

import React, { useState } from "react";
import { Header } from "./Header";
import Sidebar from "./SideBar";

export function ParentComponentWithSideBar({ children, ...rest }) {
  const [profileImage, setProfileImage] = useState({ imageUrl: null, userName: "" });

  return (
    <div className="main-wrapper">
      <Header profileImage={profileImage}/>
      <Sidebar />
      <div className="page-wrapper">
        <div className="container-fluid pb-4 inner-page-wrapper">
        {React.cloneElement(children, { setProfileImage })}
        </div>
      </div>
    </div>
  );
}
